// Confooter.tsx
import React, { useEffect, useState } from "react";
import "../styles/index.less";
import { Col, Row, Tag, Card } from "antd";
import { UserOutlined, EyeOutlined, SendOutlined } from "@ant-design/icons";
import logohead from "../../../assets/images/bg/3.png";
import { get_count_visitor } from "../../../services/visitor";
import { get_suggest_category } from "../../../services/category";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

type Props = {};

const Conhead = (props: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [visitor, setVisitor] = useState(0);
  const [user, setUser] = useState(0);
  const [task, setTask] = useState(0);
  const [tags, setTags] = useState([
    { name: "#aibenchmarking" },
    { name: "#aithailand" },
    { name: "#ai4thai" },
    { name: "#machinelearning" },
    { name: "#vision" },
    { name: "#speech" },
    { name: "#nlp" },
    { name: "#nectec" },
    { name: "#nstda" },
  ]);

  useEffect(() => {
    getHomeData();
    getTag();
  }, []);

  const getHomeData = async () => {
    try {
      const res = await get_count_visitor();
      setVisitor(res.result.view);
      setUser(res.result.user);
      setTask(res.result.task);
    } catch (e) {
      console.error(e);
    }
  };

  const getTag = async () => {
    try {
      const res = await get_suggest_category();
      setTags(res.result);
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <section className="conhead-section">
    <div className="globalcontainer">
      <Row justify="center" className="header-row">
        {/* ด้านซ้าย: หัวข้อ */}
        <Col xs={24} sm={24} md={24} lg={12} className="titlehead">
          <div className="groupone">
            <p className="topichead" style={{ color: "#052240" }}>
              AI Thailand
            </p>
            <p className="topicheadtwo" style={{ color: "#B31312" }}>
              Benchmark Programs
            </p>
            <p className="topicheadthree">
              Showcasing AI Talents in Thailand Across different shared tasks
            </p>
          </div>
        </Col>

        {/* ด้านขวา: รูปภาพ */}
        <Col xs={24} sm={24} md={24} lg={12} className="imagehead">
          <div className="maskedimage">
            <img
              src={logohead}
              alt="Masked"
              className="masked-image"
              loading="lazy"
            />
          </div>
        </Col>
      </Row>

      {/* OLD DASHBOARD SECTION */}
      {false && (
        <div className="dashboard-container">
          <Row gutter={[16, 16]} align="middle">
            {/* Left Icon */}
            <Col xs={2} md={2} lg={4} xl={3} className="colleft">
              <div style={{ float: "right" }}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1827/1827975.png"
                  alt="Hashtag Icon"
                  className="hashtag"
                />
              </div>
            </Col>

            {/* Tags */}
            <Col xs={8} md={9} lg={8} xl={9} className="colgroup">
              <div className="taggroup">
                {tags.map((tag, index) => (
                  <Tag
                    key={index}
                    className="tagname"
                    style={{ color: "#052240", border: "1px solid #052240", cursor: "pointer" }}
                    color="#ffffff"
                    onClick={() => {
                      navigate(`/task?search=${encodeURIComponent(tag.name)}`);
                    }}
                  >
                    #{tag.name}
                  </Tag>
                ))}
              </div>
            </Col>

            {/* Right Icon */}
            <Col xs={2} md={2} lg={4} xl={3} className="colright">
              <div style={{ float: "right" }}>
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1827/1827975.png"
                  alt="Hashtag Icon"
                  className="hashtag"
                />
              </div>
            </Col>

            <Col xs={14} md={13} lg={12} xl={12} className="cardbig">
              <div className="stat-card">
                <Row justify="space-between" align="middle" gutter={[16, 16]}>
                  <Col xs={8} sm={8} md={8} className="stat-item">
                    <UserOutlined className="iconcard" />
                    <h2>
                      {user
                        ? user >= 10000
                          ? (user / 10000).toFixed(1).replace(/\.0$/, "") + "k"
                          : user
                        : 0}
                    </h2>
                    <p className="cardactivity">{t("ActiveUsers")}</p>
                  </Col>
                  <Col xs={8} sm={8} md={8} className="stat-item">
                    <SendOutlined className="iconcard" />
                    <h2>
                      {task
                        ? task >= 10000
                          ? (task / 10000).toFixed(1).replace(/\.0$/, "") + "k"
                          : task
                        : 0}
                    </h2>
                    <p className="cardactivity">{t("ActiveTasks")}</p>
                  </Col>
                  <Col xs={8} sm={8} md={8} className="stat-item">
                    <EyeOutlined className="iconcard" />
                    <h2>
                      {visitor
                        ? visitor >= 10000
                          ? (visitor / 10000).toFixed(1).replace(/\.0$/, "") + "k"
                          : visitor
                        : 0}
                    </h2>
                    <p className="cardactivity">{t("Views")}</p>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </div>
      )}

      {/* NEW DASHBOARD SECTION */}
      <div className="dashboard-container">
        <Row gutter={[16, 24]} align="middle">
          {/* Tags + Hashtag Icon */}
          <Col xs={24} sm={24} md={12} lg={12}>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <div className="taggroup" style={{ flex: 1, display: "flex", flexWrap: "wrap", alignItems: "center" }}>
                {tags.map((tag, index) => (
                  <Tag
                    key={index}
                    className="tagname"
                    style={{ color: "#052240", border: "1px solid #052240", cursor: "pointer" }}
                    color="#ffffff"
                    onClick={() => {
                      navigate(`/task?search=${encodeURIComponent(tag.name)}`);
                    }}
                  >
                    #{tag.name}
                  </Tag>
                ))}
              </div>
              <span style={{
                flexShrink: 0,
                fontSize: "clamp(40px, 8vw, 80px)",
                color: "#cccccc",
                fontWeight: "bold",
                lineHeight: 1,
              }}>
                #
              </span>
            </div>
          </Col>

          {/* Stats Card */}
          <Col xs={24} sm={24} md={12} lg={12} className="cardbig">
            <div className="stat-card">
              <Row justify="space-around" align="middle" gutter={[8, 8]}>
                <Col xs={8} sm={8} md={8} className="stat-item">
                  <UserOutlined className="iconcard" />
                  <h2>
                    {user ? (user >= 10000 ? (user / 10000).toFixed(1).replace(/\.0$/, "") + "k" : user) : 0}
                  </h2>
                  <p className="cardactivity">{t("ActiveUsers")}</p>
                </Col>
                <Col xs={8} sm={8} md={8} className="stat-item">
                  <SendOutlined className="iconcard" />
                  <h2>
                    {task ? (task >= 10000 ? (task / 10000).toFixed(1).replace(/\.0$/, "") + "k" : task) : 0}
                  </h2>
                  <p className="cardactivity">{t("Tasks")}</p>
                </Col>
                <Col xs={8} sm={8} md={8} className="stat-item">
                  <EyeOutlined className="iconcard" />
                  <h2>
                    {visitor ? (visitor >= 10000 ? (visitor / 10000).toFixed(1).replace(/\.0$/, "") + "k" : visitor) : 0}
                  </h2>
                  <p className="cardactivity">{t("Views")}</p>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
    </section>
  );
};

export default Conhead;
